/*!
 * Stimpack Control - Select
 *
 * @version : 1.0
 * @author  : Matthias Courville
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';

(function($) {

    var spControlNavigation = function(root, options)
    {
        var _this = this,
            root = $(root);

        this.options = $.extend({
            name                : '',
            customItemTemplate  : '',
            selectors           : {
                customItemList      : '.sp-control-navigation-custom-items > ul',
                customItem          : '.sp-control-navigation-custom-item',
                addCustomItem       : '.sp-control-navigation-add-custom-item',
                removeCustomItem    : '.sp-control-navigation-remove-custom-item',
                encodedOutput          : '.sp-control-navigation-encoded-output'
            }
        }, options);

        this.el = {
            root                : root,
            customItemList      : root.find(this.options.selectors.customItemList),
            addCustomItem       : root.find(this.options.selectors.addCustomItem),
            encodedOutput          : root.find(this.options.selectors.encodedOutput)
        };

        this.init();
    };

    /*
     * Init
     */
    spControlNavigation.prototype.init = function()
    {
        var _this = this;

        this.el.addCustomItem.on('click', function() {
            _this.addItem();
        });

        this.el.root.on('click', this.options.selectors.removeCustomItem, function() {
            _this.removeItem($(this).closest(_this.options.selectors.customItem));
        });
    }


    /*
     * Get value
     */
    spControlNavigation.prototype.getValue = function()
    {
        var json = this.el.root.find('[name' + (this.options.name ? '*="' + this.options.name + '"' : '') + ']:not(' + this.options.selectors.encodedOutput + ')').serializeJSON({useIntKeysAsArrayIndex: false});

        if (typeof json === 'object')
        {
            if (typeof json[this.options.name] === 'object')
            {
                json = json[this.options.name];
            }
            else if (typeof json.acf === 'object')
            {
                json = json.acf;
                json = json[Object.keys(json)[0]];
            }

            return json;
        }
    };


    /*
     * Refresh
     */
    spControlNavigation.prototype.refresh = function()
    {
        this.refreshItemIndexes();
        this.updateJsonOutput(this.getValue());
    }


    /*
     * Add item
     */
    spControlNavigation.prototype.addItem = function()
    {
        var newItem = $(this.options['customItemTemplate']);

        newItem.find('[data-sp-control-select]').each(function() {
            $(this).spControlSelect();
        });

        this.el.customItemList.append(newItem);

        setTimeout(function() {
            newItem.find('[data-sp-control-text-editor]').each(function() {
                $(this).spControlTextEditor();
            });
        }, 500);

        this.refresh();
    }

    /*
     * Remove item
     */
    spControlNavigation.prototype.removeItem = function(item)
    {
        item.remove();
        this.refresh();
    }

    /*
     * Refresh item indexes
     */
    spControlNavigation.prototype.refreshItemIndexes = function()
    {
        var index = 0;

        this.el.customItemList.find('.sp-control-navigation-custom-item').each(function() {

            var block = $(this);

            block.find('[data-sp-control-name]').each(function() {

                var control = $(this),
                    name = control.data('sp-control-name');

                if (name)
                {
                    control.attr('name', name.replace('[$i]', '[' + index + ']'));
                }
            });

            index++;
        });
    }

    /*
     * Update json output
     */
    spControlNavigation.prototype.updateJsonOutput = function(value)
    {
        if (this.el.encodedOutput.length > 0)
        {
            console.log(value);
            value = typeof value === 'object' ? spBase64Encode(JSON.stringify(value)) : null;
            this.el.encodedOutput.val(value);
        }
    }


    $.fn.spControlNavigation = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-control-navigation');

            $(this).attr('data-sp-control-navigation', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spControlNavigation = new spControlNavigation(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-navigation]').each(function() {
        $(this).spControlNavigation();
    });

})(jQuery);
